import React from 'react';
import PropTypes from 'prop-types';

const Menu = props => {
  const { id, ...rest } = props;

  return (
    <svg
      id={id}
      width={24}
      height={24}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path d="M22 12c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1zM3 7h18c.6 0 1-.4 1-1s-.4-1-1-1H3c-.6 0-1 .4-1 1s.4 1 1 1zm18 10H3c-.6 0-1 .4-1 1s.4 1 1 1h18c.6 0 1-.4 1-1s-.4-1-1-1z" />
    </svg>
  );
};

Menu.propTypes = {
  id: PropTypes.string,
};

Menu.defaultProps = {
  id: 'menu',
};

export default Menu;
